import axios from 'axios'
import Vue from 'vue'
import router from '../router'

const host = process.env.VUE_APP_API_SERVER

const routes = {
  logout: host + '/pri/logout',
  users: host + '/pri/portal/users',
  newUser: host + '/pri/portal/users',
  deleteUser: host + '/pri/portal/users',
  updateUser: host + '/pri/portal/users',
  vehicles: host + '/pri/portal/vehicles',
  routes: host + '/pri/portal/routes',
  code: host + '/pri/portal/client/code',
  trackingGeo: host + '/pri/client/regioroute/tracking',
  cells: host + '/pri/portal/cells',
  permissions: host + '/pri/portal/permissions',
  assignResource: host + '/pri/portal/permissions/assignResource',
  assignPermission: host + '/pri/portal/roles/assignPermission',
  resourcesPermissions: host + '/pri/portal/permissions/readResources',
  rolePermissions: host + '/pri/portal/roles/readPermissions',
  roles: host + '/pri/portal/roles',
  incidentsReport: host + '/pri/client/incidents/getIncidentsByClient',
  userIncedent: host + '/pri/client/users/activeUsersByClient',
  devTrips: host + '/pri/portal/routes/listRoutesByUser',
  repRegRt: host + '/pri/client/runs/list',
  repRegRtConciliacion: host + '/pri/client/runs/conciliacion',
  runRegRtCommentBase: host + '/pri/client/runs',
  repRegRtReport: host + '/pri/client/runs/report',
  geoRuta: host + '/pri/client/branch/georutes',
  listRam: host + '/pri/client/branch/list/',
  ubiUnid: host + '/pri/client/units/runactive/list',
  mapRegRt: host + '/pri/client/runs/georute/',
  mapRegRtExt: host + '/pri/client/runs/extended-georoute/',
  detRd: host + '/pri/client/trips/getBoardingsReportByRoute',
  resRd: host + '/pri/client/trips/getBoardingsReportByStop',
  maps: host + '/pri/client/maps',
  tracking: host + '/pri/client/maps/tracking',
  clients: host + '/pri/client/users/clients',
  reportedTrips: host + '/pri/client/trips/getReportedTrips',
  clientUser: host + '/pri/client/user/changeUserStatusCode',
  updateClient: host + '/pri/client/user/updateUserInfo',
  deleteCode: host + '/pri/client/user/deleteCode',
  updateStatusMultiple: host + '/pri/client/van/disable/multiple/reservation',
  getEmails: host + '/pri/client/van/disable/multiple/reservation/list/emails',
  getUsers: host + '/pri/client/van/disable/multiple/reservation/list/users',
  recoveryPass: host + '/pub/recover/password',
  reset: host + '/pub/reset/password',
  bulk: host + '/pri/client/employees/program/bulkLoadByEmployee',
  empByCli: host + '/pri/client/employees/program/by/client',
  routesAvailable: host + '/pri/client/employees/program/routes/available/for/employee',
  employeesProgram: host + '/pri/client/employees/program',
  attendanceProgram: host + '/pri/client/employees/program/attendance/report',
  routesByClient: host + '/pri/client/employees/program/routesByClient',
  dataPolicies: host + '/pri/portal/users/dataPolicies/PRIVACY_POLICY/status',
  dataPoliciesLatest: host + '/pri/portal/dataPolicies/PRIVACY_POLICY/latest',
  acceptPolicies: host + '/pri/mobile/user/dataPolicies',
  publicPolicies: host + '/pub/dataPolicies/latest',
  employeesClientInfo: host + '/pri/client/employees/information',
  van: host + '/pri/client/van',
  getFile: host + '/pri/client/file/get',
  vanOffline: host + '/pri/client/offline/users/van',
  qr: host + '/pri/client/offline/users',
  noAccess: host + '/pri/client/trips/logs/updateEmployeesProgramTripPassengersLogs',
  addUsersToTrip: host + '/pri/client/van/add/users/to/trip',
  updatePassword: host + '/pri/client/user/updatePasswd',
  clientDepartures: host + '/pri/portal/dashboard/clientdepartures',
  clientDeparturesSettings: host + '/pri/portal/dashboard/clientdepartures/settings',
  clientDeparturesPlantas: host + '/pri/portal/dashboard/clientdepartures/plantas',
  clientDeparturesCheckAuth: host + '/pri/services/clientedepartures/auth',
  clientDeparturesAuth: host + '/pri/services/clientedepartures'
}

const modules = {
  home: 'CK_MAPA',
  reporteUsuarios: 'CK_REPORTES',
  EmpleadosYRutas: 'CK_EMPLEADOS',
  administracionPasajerosYViajes: 'CK_PASAJEROS',
  tracking: 'CK_MAPA_CLIENTE_NV',
  markers: 'CK_MAPA_CLIENTE_NP',
  VanOffline: 'CK_VAN_OFFLINE',
  reporteDeNoAcceso: 'CK_EMPLEADOS',
  reservaMultiple: 'CK_VAN_EMPRESARIAL_VIAJES',
  changeUserPassword: 'CK_USUARIOS_PASSWORD',
  detalleAscenso: 'CK_REPORTE_PUB_ASC',
  reportRegioRuta: 'CK_REPORTE_RR_LECTURA',
  reportRegioRutaExtendido: 'CK_REPORTE_RR_EXT_LECTURA',
  reportRegioRutaExtendidoHorarioPlan: 'CK_REPORTE_RR_EXT_HORARIO_PLAN_LECTURA',
  reportRegioRutaExtendidoHorarioReal: 'CK_REPORTE_RR_EXT_HORARIO_REAL_LECTURA',
  reportRegioRutaExtendidoDiagnosticoGps: 'CK_REPORTE_RR_EXT_DIAGNOSTICO_GPS_LECTURA',
  reportRegioRutaConciliacion: 'CK_REPORTE_RR_CONCILIACION_LECTURA',
  reportRegioRutaConciliacionComentario: 'CK_REPORTE_RR_CONCILIACION_COMENTARIO_ESCRITURA'
}

export default {
  ws: function (method, name, data, type, file) {
    let isOnline = navigator.onLine
    if (method === 'get' && type == 'url') {
      if (Vue.prototype.$session.exists()) {
        let jwt = Vue.prototype.$session.get('jwt')
        let headers = {
          Authorization: 'Bearer ' + jwt
        }
        return axios
          .get(routes[name] + '/' + data, { headers })
          .then((response) => {
            let res = response.data
            return { ok: true, data: res.data }
          })
          .catch((error) => {
            if (!isOnline) {
              return { ok: false, code: 'INTERNET_DISCONNECTED' }
            } else {
              return {
                ok: false,
                code: error.response.data.code,
                message: error.response.data.message
              }
            }
          })
      } else {
        router.push('/login')
      }
    } else if (method === 'get' && (type == 'params' || type === undefined)) {
      if (Vue.prototype.$session.exists()) {
        let jwt = Vue.prototype.$session.get('jwt')
        let headers = {
          Authorization: 'Bearer ' + jwt
        }

        let params = ''
        for (let k in data) {
          params += k + '=' + data[k] + '&'
        }
        params = params !== '' ? '?' + params : ''
        return axios
          .get(routes[name] + params, { headers })
          .then((response) => {
            let res = response.data
            return { ok: true, data: res.data }
          })
          .catch((error) => {
            if (!isOnline) {
              return { ok: false, code: 'INTERNET_DISCONNECTED' }
            } else {
              return {
                ok: false,
                code: error.response.data.code,
                message: error.response.data.message
              }
            }
          })
      } else {
        router.push('/login')
      }
    } else if (method === 'post') {
      if (Vue.prototype.$session.exists()) {
        let jwt = Vue.prototype.$session.get('jwt')
        let headers = {
          Authorization: 'Bearer ' + jwt
        }
        return axios
          .post(routes[name], data, { headers })
          .then((response) => {
            let res = response.data
            return { ok: true, data: res.data }
          })
          .catch((error) => {
            if (!isOnline) {
              return { ok: false, code: 'INTERNET_DISCONNECTED' }
            } else {
              return {
                ok: false,
                code: error.response.data.code,
                message: error.response.data.message
              }
            }
          })
      } else {
        router.push('/login')
      }
    } else if (method === 'postFile') {
      if (Vue.prototype.$session.exists()) {
        let dataFile = new FormData()
        let fileInfo = file.target.files[0]
        dataFile.append('file', fileInfo)

        let jwt = Vue.prototype.$session.get('jwt')
        let headers = {
          'Content-Type': 'multipart/form-data',
          Authorization: 'Bearer ' + jwt
        }
        return axios
          .post(routes[name], dataFile, { headers })
          .then((response) => {
            let res = response.data
            return { ok: true, data: res.data }
          })
          .catch((error) => {
            if (!isOnline) {
              return { ok: false, code: 'INTERNET_DISCONNECTED' }
            } else {
              return {
                ok: false,
                code: error.response.data.code,
                message: error.response.data.message,
                line: error.response.data.data.line
              }
            }
          })
      } else {
        router.push('/login')
      }
    } else if (method === 'put') {
      if (Vue.prototype.$session.exists()) {
        let jwt = Vue.prototype.$session.get('jwt')
        let headers = {
          Authorization: 'Bearer ' + jwt
        }
        return axios
          .put(routes[name], data, { headers })
          .then((response) => {
            let res = response.data
            return { ok: true, data: res.data }
          })
          .catch((error) => {
            if (!isOnline) {
              return { ok: false, code: 'INTERNET_DISCONNECTED' }
            } else {
              return {
                ok: false,
                code: error.response.data.code,
                message: error.response.data.message
              }
            }
          })
      } else {
        router.push('/login')
      }
    } else if (method === 'delete') {
      if (Vue.prototype.$session.exists()) {
        let jwt = Vue.prototype.$session.get('jwt')
        let headers = {
          Authorization: 'Bearer ' + jwt
        }
        return axios
          .delete(routes[name], { headers, data })
          .then((response) => {
            let res = response.data
            return { ok: true, data: res.data }
          })
          .catch((error) => {
            if (!isOnline) {
              return { ok: false, code: 'INTERNET_DISCONNECTED' }
            } else {
              return {
                ok: false,
                code: error.response.data.code,
                message: error.response.data.message
              }
            }
          })
      } else {
        router.push('/login')
      }
    }
  },
  check(option, path) {
    path = path.split('/')
    path = path[path.length - 1]
    let key = modules[path]
    if (option === 1) {
      key += '_LECTURA'
    } else if (option === 2) {
      key += '_ESCRITURA'
    } else if (option === 3) {
      key += '_ELIMINAR'
    } else {
      return false
    }
    let per = Vue.prototype.$session.get('permisos')
    return per.indexOf(key) >= 0
  },
  routes
}
